import axios from './_nestAxios'

export const descargarReporteFormato10p2xMes = ({ mes, flagAcumulado }) =>
  axios.get(`/modulos-costos/descargar/formato10p2`, {
    params: { tipoReporte: 'mensual', mes: mes, flagAcumulado },
    responseType: 'blob'
  })

export const descargarReporteFormato10p2xAnio = () =>
  axios.get(`/modulos-costos/descargar/formato10p2`, { params: { tipoReporte: 'anual' }, responseType: 'blob' })
